import type { CompoundEntityRef, Entity } from '@backstage/catalog-model';

import { getCompoundEntityRef, parseEntityRef } from '@backstage/catalog-model';
import { isEntity } from '@ipen-portal/ipen-entity-model';

export const createEntityRefFilter = (
  ref: CompoundEntityRef | Entity | string,
  fallbackKind?: string,
): string[] => {
  const parsedRef = isEntity(ref)
    ? getCompoundEntityRef(ref)
    : parseEntityRef(ref, { defaultKind: fallbackKind });
  const kind = parsedRef.kind.toLocaleLowerCase();
  return [
    parsedRef.name,
    `${kind}:${parsedRef.name}`,
    `${kind}:${parsedRef.namespace}/${parsedRef.name}`,
    `${parsedRef.namespace}/${parsedRef.name}`,
  ];
};
